export const cwd = (baseClassName: string, modifiersObj?: Record<string, boolean>): string => {
  return (
    baseClassName +
    (modifiersObj
      ? Object.entries(modifiersObj)
          .filter(([, shouldApply]) => !!shouldApply)
          .map(([modifier]) => ` ${baseClassName}--${modifier}`)
      : '')
  )
}
